import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function LoadLicense({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Load License File"
      left="No"
      right="Yes"
      caption="This may change the licensed features.  Continue?"
    />
  );
}

export default LoadLicense;
